export const cylinderPredictionFilterOptions = [
  {
    name: "Station",
    value: [["station_id"]],
    label: [["station_name"]],
  },
  {
    name: "Field Technician",
    value: [["fieldTechnician", "id"]],
    label: [["fieldTechnician", "fullName"]],
  },
];

export const idleCylindersFilterOptions = [
  {
    name: "Field Technician",
    value: [["jbccFtId"]],
    label: [["jbccFtName"]],
  },
  {
    name: "Supervisor",
    value: [["jbccSupId"]],
    label: [["jbccSupName"]],
  },
];

export const IDLE_CYLINDERS_SEARCH_OPTIONS = {
  site: ["stationName"],
  id: ["stationId"],
  machine: ["machineId"],
};
